module.exports = __webpack_public_path__ + "img/meiyan.8facd84a.webp";